import React from 'react'
import Section from '../_common/Section'

export default () => {
  return (
    <Section
      title="入居者検索"
      category="residents"
      mainID="id"
      labels={[
        {
          id: 'id',
          name: 'ID'
        },
        {
          id: 'name',
          name: '氏名'
        },
        {
          id: 'owner_name',
          name: '管理会社名・オーナー名'
        },
        {
          id: 'property_name',
          name: '物件名'
        },
        {
          id: 'tel',
          name: '電話番号'
        },
        {
          id: 'created_date',
          name: '作成日'
        },
        {
          id: 'push',
          name: 'プッシュ通知'
        },
        {
          id: 'chat',
          name: 'チャット'
        }
      ]}
      // labels={['ID', '氏名', '性別', '電話番号', '物件名', '部屋番号', '作成日']}
      // labelsID={[ 'resident_id', 'name', 'sex', 'tel', 'property_name', 'room_id', 'created' ]}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/Residents/index.js